module.exports = __webpack_public_path__ + "static/media/WHATS.08c8bc0d.jpg";